import React, { createContext, useReducer, useMemo } from "react";

let CesionContext = createContext();

let initialState = {
  openCesion: false,
  documento: {}
};

let reducer = (state, action) => {
  switch (action.type) {
    case "reset": {
      return initialState;
    }
    case "toggleCesion": {
      return { ...state, openCesion: !state.openCesion };
    }
    case "setDocumentoCesion": {
      return { ...state, documento: action.data };
    }
    default:
      return state;
  }
};

function CesionProvider(props) {
  let [state, dispatch] = useReducer(reducer, initialState);
  let value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <CesionContext.Provider value={value}>{props.children}</CesionContext.Provider>
  );
}

let CesionConsumer = CesionContext.Consumer;

export { CesionContext, CesionProvider, CesionConsumer };